import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { COUNTRIES } from "../../constants";

const CountriesReach = () => {
  return (
    <section className="py-12 px-4 sm:px-8 bg-white text-gray-800">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl font-bold mb-6">
          Trusted Around the World
        </h2>
        <p className="mb-8 text-lg sm:text-xl">
          Athletes from these countries have already started their journey with
          us!
        </p>
        <div className="relative">
          <Swiper
            modules={[Navigation]}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            spaceBetween={20}
            slidesPerView={2}
            breakpoints={{
              640: { slidesPerView: 3 },
              768: { slidesPerView: 4 },
              1024: { slidesPerView: 5 },
            }}
            loop={true}
          >
            {COUNTRIES.map((country, index) => (
              <SwiperSlide
                key={index}
                className="bg-gray-100 rounded-xl p-6 flex flex-col items-center justify-center shadow-md hover:shadow-lg transition"
              >
                <div className="text-5xl mb-2">{country.flag}</div>
                <div className="text-base font-semibold text-center">
                  {country.name}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom Arrows */}
          <div className="swiper-button-prev !text-gray-800 !text-3xl !left-0"></div>
          <div className="swiper-button-next !text-gray-800 !text-3xl !right-0"></div>
        </div>
      </div>
    </section>
  );
};

export default CountriesReach;
